import { GET_PERIODS_FOR_CHILD_DISABILITY } from "../../../enums/Request/request.types";

export const getPeriodsForChildDisability = (data) => {
    return  {
        type: GET_PERIODS_FOR_CHILD_DISABILITY,
        payload: data,
    }
}
